import { ISelectProp } from 'interfaces/SelectProp';
import React from 'react';
import Select, { ActionMeta, SingleValue, ControlProps } from 'react-select';
import { CSSObject } from '@emotion/react';
import CreatableSelect from 'react-select/creatable';

interface ISingleSelect {
  white?: boolean;
  creatable?: boolean;
  disabled?: boolean;
  placeholder?: string;
  error?: boolean;
  onChange:
    | ((newValue: SingleValue<ISelectProp>, actionMeta: ActionMeta<ISelectProp>) => void)
    | undefined;
  options: ISelectProp[];
  value: ISelectProp | undefined;
}

const SingleSelectView: React.FC<ISingleSelect> = ({
  white = false,
  creatable = false,
  disabled = false,
  placeholder,
  error,
  options,
  onChange,
  value,
}) => {
  const style = {
    control: (baseStyles: CSSObject, state: ControlProps<ISelectProp, false>) =>
      error
        ? {
            ...baseStyles,
            borderRadius: '4px',
            boxShadow: 'none',
            minHeight: '40px',
            borderColor: 'red',
            color: 'red',
            outline: state.isFocused ? '2px red solid' : '2px transparent solid',
            outlineOffset: '-2px',
            ':hover': { borderColor: state.isFocused ? 'transparent' : 'rgb(1, 25, 91)' },
            background: `${white ? '#ffff' : '#fafafa'}`,
          }
        : {
            ...baseStyles,
            borderRadius: '4px',
            boxShadow: 'none',
            minHeight: '40px',
            borderColor: '#E3E7EA',
            outline: state.isFocused ? '2px #3A63F8 solid' : '2px transparent solid',
            outlineOffset: '-2px',
            ':hover': { borderColor: state.isFocused ? 'transparent' : 'rgb(1, 25, 91)' },
            background: `${white ? '#ffff' : '#fafafa'}`,
          },
    placeholder: (baseStyles: CSSObject) => ({
      ...baseStyles,
      color: error ? 'red' : '#999',
    }),
  };

  return creatable ? (
      <CreatableSelect
        isDisabled={disabled}
        styles={style}
        placeholder={placeholder}
        options={options || []}
        onChange={onChange}
        value={value}
      />

  ) : (
    <Select
      styles={style}
      isDisabled={disabled}
      placeholder={placeholder}
      options={options || []}
      onChange={onChange}
      value={value}
    />
  );
};

export default SingleSelectView;
